var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"into-guide",style:(_vm.backgroundImg)},[_c('div',{staticClass:"into-guide-center"},[_c('div',{staticClass:"into-logo"},[_c('img',{attrs:{"src":_vm.intoLogoUrl,"alt":""}})]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }